import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';

import lazyGettext from 'js-utils/lazy-gettext';
import Button from 'eventbrite_design_system/button/Button';
import Icon from 'eventbrite_design_system/icon/Icon';
import LogoAppleSVG from 'eventbrite_design_system/iconography/icons/LogoApple';

import { SIZE_BLOCK } from 'eventbrite_design_system/button/constants';

import './AppleLoginButton.scss';

export default class AppleLoginButton extends Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
    };

    componentDidMount() {
        ((doc, tagName, id, appleInit) => {
            const firstScriptTag = doc.getElementsByTagName(tagName)[0];

            if (isNull(doc.getElementById(id))) {
                // if the script tag is not present
                const scriptTag = doc.createElement('script');
                scriptTag.id = id;
                scriptTag.src =
                    '"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"';
                firstScriptTag.parentNode.insertBefore(
                    scriptTag,
                    firstScriptTag,
                );
            }

            if (appleInit) {
                appleInit();
            }
        })(document, 'script', 'apple-id-auth', this.appleInit);
    }

    appleInit = () => {
        const { clientId, scope, redirectURI } = this.props;

        if (this.areParametersValid()) {
            AppleID.auth.init({
                clientId,
                scope,
                redirectURI,
            });
        }
    };

    handleClick = () => {
        const { onClick } = this.props;
        onClick();
        AppleID.auth.signIn();
    };

    areParametersValid = () => {
        const { clientId, redirectURI } = this.props;

        return clientId && redirectURI;
    };

    render() {
        return (
            <div className="apple-login__container">
                <Button
                    type="button"
                    size={SIZE_BLOCK}
                    onClick={this.handleClick}
                    disabled={!this.areParametersValid()}
                >
                    <div className="apple-login__icon">
                        <Icon
                            type={<LogoAppleSVG />}
                            size="small"
                            color="white"
                        />
                    </div>
                    <div className="apple-login__text">
                        {lazyGettext('Continue with Apple')}
                    </div>
                </Button>
            </div>
        );
    }
}
